import { GraphQLClients } from '@spotahome/ui-library';

export default GraphQLClients.tenant;
